export const GET_ALL_NOTIFICATIONS = "GET_ALL_NOTIFICATIONS";
export const RESET_DATA = "RESET_DATA";
export const START_LOADING_NOTIFICATIONS = "START_LOADING_NOTIFICATIONS";
export const STOP_LOADING_NOTIFICATIONS = "STOP_LOADING_NOTIFICATIONS";
export const ERROR_LOADING_NOTIFICATIONS = "ERROR_LOADING_NOTIFICATIONS";